<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table (detail)="onDetail($event)" (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns"
                  [dataProviderParams]="params" [dataProvider]="codeSnippetService" [title]="'CodeSnippets'" [searchColumns]="searchColumns"
                  [searchAll]="true"></data-table>
</page-content>
